import { combineReducers } from 'redux';
import i18n from '@shared/config/i18n';
import { request, getSuccess, requestFail } from '../actions/rizersActionGenerator';
import { fetchingReducer, errorReducer, dataReducer } from './commonReducers';

const { t } = i18n;

const isFetching = fetchingReducer([request], [getSuccess, requestFail], false);
const error = errorReducer([requestFail], [request], null);

const format = (data) => ({
  [`${data.building_id}`]: {
    ...data,
    building_id: `${data.building_id}`,
    rizers: data.rizers.reduce(
      (acc, item) => [
        ...acc,
        {
          value: item,
          title: item === 0 ? t('gate') : `${t('EntranceNumber')} ${item}`,
        },
      ],
      []
    ),
  },
});

const data = dataReducer(
  {
    create: 'NO_ACTION',
    update: 'NO_ACTION',
    delete: 'NO_ACTION',
    get: getSuccess,
    getReducer: (state, action) => ({ ...state, ...format(action.payload) }),
  },
  {}
);

const rizers = combineReducers({
  isFetching,
  error,
  data,
});

export default rizers;
